/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Col_PlayerInputs */



/**
* | output |
* | --- |
* | "Player" |
*
* @param {Tournament_Col_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_col_player = /** @type {((inputs?: Tournament_Col_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Col_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatore")
	return /** @type {LocalizedString} */ ("Player")
});